import { Box, Button, DataTable, Text, grommet, Grommet } from 'grommet';
import { FormNext } from 'grommet-icons';
import React, { useEffect, useState } from 'react';
import { HitScopeClip } from '../hitScope.types';
import { analytics } from '../../../services/analytics';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface ClipsDataTableProps {
  data: HitScopeClip[];
  selectedClipId: string;
  playerId?: string;
  onSelected: (datum: HitScopeClip) => void;
  track: { playerId?: string; type: string };
}

const ClipsDataTable: React.FC<ClipsDataTableProps> = ({
  data,
  onSelected,
  selectedClipId,
  playerId,
  track,
}) => {
  const [selectedId, setSelectedId] = useState(selectedClipId);
  useEffect(() => {
    setSelectedId(selectedClipId);
  }, [selectedClipId]);

  const inningOrOpponent = () => {
    if ('inning' in data[0]) {
      return {
        property: 'inning',
        header: 'Inning',
      };
    } else {
      return {
        property: 'opponent',
        header: 'Opponent',
      };
    }
  };

  const columns = [
    {
      property: 'date',
      header: <Text>Date</Text>,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render: (datum: any) =>
        datum.date &&
        new Date(datum.date).toLocaleDateString('en-US', {
          year: '2-digit',
          month: 'numeric',
          day: 'numeric',
        }),
    },
    inningOrOpponent(),
    {
      property: 'outcome',
      header: 'Outcome',
    },
    {
      property: 'more',
      header: 'More',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      render: (datum: any) => (
        <Button
          data-testid="hitscope-full-ab-button"
          alignSelf="center"
          justify="end"
          plain
          reverse
          gap="xxsmall"
          label={<Text size="xsmall">Full AB</Text>}
          icon={<FormNext size="small" />}
          onClick={(e) => {
            analytics.track('HitScope Full AB Click', {
              clipId: datum.id,
            });
            e.stopPropagation();
            if (playerId) {
              window.open(`/${playerId}/c/${datum.id}`, '_blank');
            } else {
              window.open(`/${datum.playerId}/c/${datum.id}`, '_blank');
            }
          }}
        />
      ),
    },
  ];

  const rowProps: { [key: string]: { background: string } } = {};
  rowProps[selectedId] = { background: 'light-5' };

  return (
    <Grommet theme={grommet}>
      <Box align="center">
        <DataTable
          data-testid="hitscope-data-table"
          fill
          border={false}
          columns={columns}
          data={data}
          primaryKey="id"
          rowProps={rowProps}
          onClickRow={(event) => {
            analytics.track('HitScope Timestamp Clicked', {
              ...track,
            });
            setSelectedId(event.datum.id);
            onSelected(event.datum);
          }}
        />
      </Box>
    </Grommet>
  );
};

export default ClipsDataTable;
